import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from '@tanstack/react-query';
import useSession from '../use-session';
const useOrgSession = () => {
  const $ = _c(13);
  const {
    data: sessionData,
    dangerouslyCastedData: dangerouslySessionData,
    isLive,
    setIsLive,
    logIn
  } = useSession();
  const queryClient = useQueryClient();
  const dangerouslyCastedData = dangerouslySessionData.org;
  const data = sessionData.org;
  const canToggle = sessionData.org?.isSandboxRestricted === false;
  let t0;
  if ($[0] !== isLive || $[1] !== queryClient || $[2] !== setIsLive) {
    t0 = async () => {
      await setIsLive(!isLive);
      queryClient.invalidateQueries({
        queryKey: ["org"]
      });
    };
    $[0] = isLive;
    $[1] = queryClient;
    $[2] = setIsLive;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const toggle = t0;
  const t1 = !isLive;
  let t2;
  if ($[4] !== canToggle || $[5] !== t1 || $[6] !== toggle) {
    t2 = {
      canToggle,
      isSandbox: t1,
      toggle
    };
    $[4] = canToggle;
    $[5] = t1;
    $[6] = toggle;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const sandbox = t2;
  let t3;
  if ($[8] !== dangerouslyCastedData || $[9] !== data || $[10] !== logIn || $[11] !== sandbox) {
    t3 = {
      dangerouslyCastedData,
      data,
      sandbox,
      logIn
    };
    $[8] = dangerouslyCastedData;
    $[9] = data;
    $[10] = logIn;
    $[11] = sandbox;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
export default useOrgSession;